<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.5 3.27344H16.504C18.987 3.27344 21 5.28644 21 7.76944V16.7784C21 19.2604 18.987 21.2734 16.504 21.2734H7.496C5.013 21.2734 3 19.2604 3 16.7774V7.77344C3 5.28844 5.015 3.27344 7.5 3.27344V3.27344Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.12109 11.3735V16.7735"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.7188 16.7735V13.6235C11.7188 12.3805 12.7257 11.3735 13.9688 11.3735V11.3735C15.2118 11.3735 16.2188 12.3805 16.2188 13.6235V16.7735"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.11619 8.11143C7.99219 8.11143 7.89119 8.21243 7.89219 8.33643C7.89219 8.46043 7.99319 8.56143 8.11719 8.56143C8.24119 8.56143 8.34219 8.46043 8.34219 8.33643C8.34219 8.21143 8.24119 8.11143 8.11619 8.11143"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
